import { render, staticRenderFns } from "./AccountContainer.vue?vue&type=template&id=24f169e4"
import script from "./AccountContainer.vue?vue&type=script&lang=js"
export * from "./AccountContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f169e4')) {
      api.createRecord('24f169e4', component.options)
    } else {
      api.reload('24f169e4', component.options)
    }
    module.hot.accept("./AccountContainer.vue?vue&type=template&id=24f169e4", function () {
      api.rerender('24f169e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountContainer.vue"
export default component.exports